// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q451QZVPGKsSOOLauTNN {
    position: relative;
}

.Q451QZVPGKsSOOLauTNN:before,
.Q451QZVPGKsSOOLauTNN:after {
    visibility: hidden;
    pointer-events: none;
}

.Q451QZVPGKsSOOLauTNN:hover:after,
.Q451QZVPGKsSOOLauTNN:hover:before {
    visibility: visible;
}

.Q451QZVPGKsSOOLauTNN:before {
    background-color: #32445A;
    border-radius: 3px;
    border: 1px solid white;
    color: white;
    content: attr(data-tooltip);
    font-size: 12px;
    line-height: 1.5;
    padding: 5px 3px 5px 8px;
    position: absolute;
    transform: translateY(-100%);
    width: 196px;
}
`, "",{"version":3,"sources":["webpack://./src/components/tooltip/tooltip.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;AAChB","sourcesContent":[".tooltip {\n    position: relative;\n}\n\n.tooltip:before,\n.tooltip:after {\n    visibility: hidden;\n    pointer-events: none;\n}\n\n.tooltip:hover:after,\n.tooltip:hover:before {\n    visibility: visible;\n}\n\n.tooltip:before {\n    background-color: #32445A;\n    border-radius: 3px;\n    border: 1px solid white;\n    color: white;\n    content: attr(data-tooltip);\n    font-size: 12px;\n    line-height: 1.5;\n    padding: 5px 3px 5px 8px;\n    position: absolute;\n    transform: translateY(-100%);\n    width: 196px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `Q451QZVPGKsSOOLauTNN`
};
export default ___CSS_LOADER_EXPORT___;
